import { render, staticRenderFns } from "./TouristDialogDetail.vue?vue&type=template&id=760ae46c&scoped=true"
import script from "./TouristDialogDetail.vue?vue&type=script&lang=js"
export * from "./TouristDialogDetail.vue?vue&type=script&lang=js"
import style0 from "./TouristDialogDetail.vue?vue&type=style&index=0&id=760ae46c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ae46c",
  null
  
)

export default component.exports